class ESSTreeNode {
  constructor(name, type) {
    this.label = name
    this.type = type
    this.children = null
  }
  addChild(node) {
    if (Array.isArray(this.children)) {
      this.children.push(node)
    } else {
      this.children = [node]
    }
  }
}

class ELinkNode extends ESSTreeNode {
  constructor(name) {
    super(name, 'elink')
  }
  addEBlock(eblock) {
    if (eblock instanceof EBlockNode) {
      this.addChild(eblock)
    }
  }
}

class UnitNode extends ESSTreeNode {
  constructor(name) {
    super(name, 'unit')
  }
  addELink(elink) {
    if (elink instanceof ELinkNode) {
      this.addChild(elink)
    }
  }
}

class EBlockNode extends ESSTreeNode {
  constructor(name) {
    super(name, 'eblock')
  }
}


class ESSTree {
  constructor(name) {
    this.root = new ESSTreeNode(name, 'station')
  }
  addUnit(node) {
    this.root.addChild(node)
  }
  setName(name) {
    this.root.label = name
  }
}



export {
  ESSTree,
  UnitNode,
  EBlockNode,
  ELinkNode
}
